interface MeddiAppJsStructure {
	call: {
		state?: string;
		hangUp: () => void;
	};
}

const useMeddiApp = () => {
	const getActualState = (): MeddiAppJsStructure => {
		// @ts-ignore
		return window['_meddiApp'];
	};

	const isCallActive = () => {
		return getActualState().call.state !== null;
	};

	const hangUpCall = () => {
		return getActualState().call.hangUp();
	};

	return {
		isCallActive,
		hangUpCall,
	};
};

export default useMeddiApp;
